import React, { Component } from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import classnames from 'classnames';
import { LazyLoadComponent, trackWindowScroll } from 'common/components/lazy_load';
import HomeSubcatSelect from 'marketing/containers/hero_subcat_select';
import CategoriesSlider from 'landing_pages/containers/categories';
import TestimonialSlider from 'marketing/common/testimonial_slider';
import Featured from 'marketing/common/featured';
import Support from 'marketing/containers/support';
import How3 from 'landing_pages/components/how_3';
import Image from 'common/components/image';

const BRAND_ICONS = [{
  url: "https://assets.crowdspring.com/marketing/fcb-logo-transparent-60x60.png",
  alt: "Foote, Cone & Belding (FCB) logo",
}, {
  url: "https://assets.crowdspring.com/marketing/cpb-logo-transparent-200x60.png",
  alt: "Crispin Porter + Bogusky (CP+B) logo",
}, {
  url: "https://assets.crowdspring.com/marketing/bbh-logo-transparent-60x60.png",
  alt: "Bartle Bogle Hegarty (BBH) logo",
}, {
  url: "https://assets.crowdspring.com/marketing/shift-communications-logo-transparent-200x60.png",
  alt: "Shift Communications logo",
}, {
  url: "https://assets.crowdspring.com/marketing/p%26g-2018-logo-transparent-60x60.png",
  alt: "Procter & Gamble Company (P&G) logo",
}, {
  url: "https://assets.crowdspring.com/marketing/amazon-logo-transparent-60x60.png",
  alt: "Amazon logo",
}, {
  url: "https://assets.crowdspring.com/marketing/lg-logo-transparent-200x60.png",
  alt: "LG logo",
}, {
  url: "https://assets.crowdspring.com/marketing/starbucks-logo-transparent-60x60.png",
  alt: "Starbucks logo",
}, {
  url: "https://assets.crowdspring.com/marketing/barilla-logo-transparent-200x60.png",
  alt: "Brailla logo",
}];

const TESTIMONIALS = [
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_cori-newlander.jpg',
    title: 'I can\'t speak highly enough of crowdspring.',
    quote: 'I started with a small budget and some boring content, and within a short time, I had some amazing designs to choose from. The hardest part was choosing one!',
    author: 'Cori Newlander, City of Santa Monica',
  },
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_christina-catalano.jpg',
    title: 'I am thrilled with the professional and eye-catching final design!',
    quote: "I had over 100 entries that were creative, unique, and specific to my design ideas. I would asbsolutely recommend crowdspring to any professional who doesn't have an in-office creative team.",
    author: 'Christina Catalano, Catalano & Associates',
  },
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_jeff-knowles.jpg',
    title: 'Crowdspring will be my first stop for my future creative needs.',
    quote: "I've had great success with crowdspring, using the website to both redesign an existing website and to create a website from scratch. Both projects produced a large number of high quality design options.",
    author: 'Jeff Knowles',
  },
];

class TitleSubcats extends Component {
  constructor(props) {
    super(props);

    this.subcats = [
      "logo design", "business name", "website design", "package design", "product design",
      "print design", "banner ads", "landing pages", "mobile apps", "book covers", "t-shirt design",
      "illustration", "and more!"
    ];

    this.links = [
      "/logo-design/", "/naming-a-business-or-product/", "/website-design/", "/packaging-design/",
      "/product-design/", "/outdoor-or-signage-design/", "/web-banner-design/",
      "/landing-page-design/", "/mobile-ui-design/", "/book-cover-design/",
      "/t-shirt-design/", "/illustration-and-graphic-design/", "/categories/"
    ];

    this.state = { currentSubcatIdx: 0 };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({ currentSubcatIdx: (this.state.currentSubcatIdx + 1) % this.subcats.length });
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { currentSubcatIdx } = this.state;
    const subcat = this.subcats[currentSubcatIdx];
    const link = this.links[currentSubcatIdx];

    return (
      <span className="title-subcats">
        Powerfully simple custom design. <br className="hide-for-small-only" />
        Choose the custom <Link key={currentSubcatIdx} to={link}>{ subcat }</Link>
        <br /> that helps you accelerate revenue.
      </span>
    );
  }
}

const HomeContent = ({ scrollPosition }) => {
  return (
    <div className="hero-content">
      <section className="hero">
        <div className="row hero-row">
          <div className="small-16 xlarge-8 columns">
            <div className="hero-container">
              <h1 className="hero-title">
                <TitleSubcats />
              </h1>
              <p className="hero-text">
                Join 60,000+ businesses, agencies, and nonprofits <br className="hide-for-small-only" />
                that leverage crowdspring to grow their businesses <br className="hide-for-small-only" />
                through high-quality custom design and naming.
              </p>
              <HomeSubcatSelect />
            </div>
          </div>
          <div className="hide-for-xlarge small-16 columns">
            <div className="artwork-container text-center">
              <Image
                className="hero-art"
                src="cs-illustration-homepage-purple-content-only.png"
                widths={[400]}
                alt="crowdspring HERO illustration with a group around a table looking at various logo designs"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="block block-trusted-by">
        <div className="row columns small-16">
          <h3 className="as-h4-important text-center">
            Trusted by top agencies and Brands, including:
          </h3>
        </div>
        <div className="row align-center align-middle">
          { BRAND_ICONS.map((b, i) => (
          <div className="column small-4 large-expand text-center" key={i}>
            <Image src={b.url} alt={b.alt} />
          </div>
          )) }
        </div>
      </section>
      <section className="block block-brand">
        <div className="row columns">
          <div className="block-header">
            <h2>Build a brand your customers love</h2>
          </div>
        </div>
        <div className="row small-up-1 large-up-3">
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <Image
                  src="https://assets.crowdspring.com/marketing/cs-guarantee-illustration-homepage.jpg"
                  alt="blue illustration showing 100% money back guarantee promise from crowdspring"
                />
              </div>
              <h3>Guarantee?</h3>
              <h3>You betcha...</h3>
              <p>
                If you're not 100% happy with your design project, we'll promptly refund all
                of your money.
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <Image
                  src="https://assets.crowdspring.com/marketing/cs-contract-illustration-homepage.jpg"
                  alt="colorful illustration showing that every crowdspring project is protected by a legal contract"
                />
              </div>
              <h3>IP protection?</h3>
              <h3>Ahead of the pack...</h3>
              <p>
                Industry-leading IP protections. You will own your winning design and you can
                use it any way you like.
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <Image
                  src="https://assets.crowdspring.com/marketing/cs-choice3-illustration-homepage.png"
                  alt="colorful illustration showing that you get maximum choice for logo design and other projects on crowdspring"
                />
              </div>
              <h3>Variety and choice?</h3>
              <h3>Raising the bar...</h3>
              <p>
                Original custom designs from 220,000+ quality-vetted creatives.
                Everything you need, in one place.
              </p>
            </div>
          </div>
        </div>
      </section>
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <section className="block block-categories">
          <div className="row columns">
            <div className="block-header">
              <h2>Whatever you need, we've got you covered.</h2>
            </div>
          </div>
          <CategoriesSlider sortByPopularity={true} />
          <div className="row columns text-center">
            <Link to="/categories/">See all project categories</Link>
          </div>
        </section>
      </LazyLoadComponent>
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <How3 />
      </LazyLoadComponent>
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <section className="block block-scales">
          <div className="row columns">
            <div className="block-header">
              <h2>Crowdspring scales to meet the needs of any business</h2>
            </div>
          </div>
          <div className="row">
            <div className="columns small-16 large-8 text-center">
              <h3>Manage an agency or consultancy?</h3>
              <Image
                src="https://assets.crowdspring.com/marketing/cs-agency-illustration-optimized.png"
                alt="crowdspring illustration - person at desk working on many different projects"
              />
              <p>
                Many of the world's best boutiques to large agencies leverage crowdspring
                to innovate their businesses and increase client choice. Do more, in less time,
                with fewer capital expenses.
              </p>
              <Link to="/agencies/">Learn more</Link>
            </div>
            <div className="columns small-16 large-8 text-center">
              <h3>Own or operate a business?</h3>
              <Image
                src="https://assets.crowdspring.com/marketing/cs-business-illustration-optimized.png"
                alt="crowdspring illustration - small businesses in a typical town or city"
              />
              <p>
                Company name, logo, web design, and more - whatever you need, we've got it.
                Our flexible pricing is perfect for businesses of any size. Know up front
                exactly what you'll pay.
              </p>
              <Link to="/how-it-works/">Learn more</Link>
            </div>
          </div>
        </section>
      </LazyLoadComponent>
      <TestimonialSlider
        title={<h2>Loved by over 60,000 agencies and businesses around the world</h2>}
        items={TESTIMONIALS}
      />
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Featured showAdsWeek={true} />
      </LazyLoadComponent>
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <section className="block block-easy-to-start">
          <div className="row columns small-16 large-10 text-center">
            <div className="easy-to-start">
              <span className="text">
                It's easy to get started. And it's guaranteed. Two things everyone loves.
              </span>
              <Link to="/start-a-project/" className="btn btn-primary">Get started</Link>
            </div>
          </div>
        </section>
      </LazyLoadComponent>
      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Support />
      </LazyLoadComponent>
    </div>
  );
}

export default trackWindowScroll(HomeContent);
